import DeferredOverlays from '@app/DeferredOverlays';
import { AppBackground } from '@/components/layout';
import { CoachmarkProvider } from '@/components/ui/Coachmark';
import { Outlet } from 'react-router-dom';

export default function Application() {
  return (
    <CoachmarkProvider>
      <AppBackground>
        <Outlet />
        <DeferredOverlays />
      </AppBackground>
    </CoachmarkProvider>
  );
}